import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material';
import {
  MatInputModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSortModule, MatTableModule,

} from '@angular/material';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MarkdownModule } from 'ngx-markdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { UserIdleModule } from 'angular-user-idle';
import { HealthComponent } from './health/health.component';

@NgModule({
  declarations: [
    AppComponent,
    HealthComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    MatSidenavModule,
    MarkdownModule.forRoot(),
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    NgxPaginationModule,
    NgxMaterialTimepickerModule,

    UserIdleModule.forRoot({ idle: 900, timeout: 10, ping: 10 })
  ],
  providers: [
    Title,
    DatePipe,
  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
